import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import StatsSection from "./components/StatsSection";
import CategoriesSection from "./components/CategoriesSection";
import ArticlesSection from "./components/ArticlesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "爱情岛网站",
            url: "https://www.aiqingdao.com/",
            description:
              "爱情岛网站是深受用户喜爱的在线交友与娱乐平台，提供丰富的互动功能、安全稳定的访问入口与极致的用户体验。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.aiqingdao.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "爱情岛网站是免费的吗？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "爱情岛网站提供免费注册和基础功能使用。您可以通过免费注册创建账号、浏览用户资料、使用基础匹配功能。平台也提供VIP会员服务，VIP会员可享受无限私信、高级搜索筛选、优先推荐等增值功能。",
                },
              },
              {
                "@type": "Question",
                name: "如何保证账号安全？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "爱情岛网站采用多重安全保护措施：所有数据采用SSL加密传输，用户密码经过加密哈希存储，支持手机验证码登录和指纹/面部识别登录。",
                },
              },
              {
                "@type": "Question",
                name: "注册需要提供哪些信息？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "基础注册只需提供手机号码和设置密码即可完成。建议完善个人资料，包括昵称、头像、性别、年龄、所在城市、兴趣爱好等。",
                },
              },
              {
                "@type": "Question",
                name: "如何举报不良用户？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "您可以在该用户的主页点击「举报」按钮，选择举报原因并提交。审核团队会在24小时内处理您的举报。您也可以将不良用户加入黑名单。",
                },
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <StatsSection />
        <CategoriesSection />
        <ArticlesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}